import jquery from "jquery";
window.jQuery = jquery;
window["$"] = jquery;
//# sourceMappingURL=jquery-global.js.map